export default [
    {
        product: 'Wood Protector',
        handle: 'timbashield-wood-protector',
        types: [
            {
                name: 'Rough Wood',
                coverage: [
                    {
                        label: 'One Coat (Standard Protection)',
                        per_litre: 10,
                    },
                    {
                        label: 'Two Coats (Best Protection)',
                        per_litre: 6,
                    }
                ]
            },
            {
                name: 'Smooth Wood',
                coverage: [
                    {
                        label: 'One Coat (Standard Protection)',
                        per_litre: 15,
                    },
                    {
                        label: 'Two Coats (Best Protection)',
                        per_litre: 9,
                    }
                ]
            },
            {
                name: 'Redecoration',
                coverage: [
                    {
                        label: 'One Coat',
                        per_litre: 10,
                    }
                ]
            },
        ],
        comments:
            'For full protection on untreated wood, we recommend using 2 coats. The first coat soaks deeply into the wood and the second coat seals the wood at the surface for advanced protection. Further coats can be used to deepen the colour, or to refresh the coating after an extended period of time outdoors. To maintain the best protection we suggest recoating every 1-2 years. Coverage levels are to be used as a guide and may vary depending on the structure and the type of wood.',
    },
    {
        product: 'Wood Preserver',
        handle: 'timbashield-wood-preserver',
        types: [
            {
                name: 'Rough Wood',
                coverage: [
                    {
                        label: 'One Coat',
                        per_litre: 8,
                    },
                    {
                        label: 'Two Coats (Standard Protection)',
                        per_litre: 5,
                    },
                    {
                        label: 'Three Coats (Best Protection)',
                        per_litre: 3,
                    }
                ]
            },
            {
                name: 'Smooth Wood',
                coverage: [
                    {
                        label: 'One Coat',
                        per_litre: 9,
                    },
                    {
                        label: 'Two Coats (Standard Protection)',
                        per_litre: 6,
                    },
                    {
                        label: 'Three Coats (Best Protection)',
                        per_litre: 4,
                    }
                ]
            },
        ],
        comments:
            'Due to its use on bare wood, coverage levels will vary depending on the porosity, structure and type of wood used. For full protection, we recommend using 2-3 coats. The first coat soaks deeply into the wood. Subsequent layers will give a larger area of coverage as the absorption of the product decreases until maximum protection is reached',
    },
    {
        product: 'Water Sealer',
        handle: 'timbashield-water-sealer',
        types: [
            {
                name: 'Rough Wood',
                coverage: [
                    {
                        label: 'One Coat (Standard Protection)',
                        per_litre: 8,
                    },
                    {
                        label: 'Two Coats (Best Protection)',
                        per_litre: 5,
                    }
                ]
            },
            {
                name: 'Smooth Wood',
                coverage: [
                    {
                        label: 'One Coat (Standard Protection)',
                        per_litre: 9,
                    },
                    {
                        label: 'Two Coats (Best Protection)',
                        per_litre: 6,
                    }
                ]
            },
        ],
        comments:
            'Due to its use on bare wood, coverage levels will vary depending on the porosity, structure and type of wood used. Rough sawn, absorbant wood may require a higher volume. For full protection, we recommend using 1-2 coats. Please note that the due to the differences in porosity of some wooden surfaces, rough sawn, absorbant wood may require a higher volume of product. This is due to how much product is absorbed. Water beading may be less visable on porous surfaces as the product is deeper into the wood- but performance is not affected.',
    },
    {
        product: 'Decking Protector',
        handle: 'timbashield-decking-protector',
        types: [
            {
                name: 'Untreated',
                coverage: [
                    {
                        label: 'One Coat (Standard Protection)',
                        per_litre: 7,
                    },
                    {
                        label: 'Two Coats (Best Protection)',
                        per_litre: 5,
                    }
                ]
            },
            {
                name: 'Redecoration',
                coverage: [
                    {
                        label: 'One Coat',
                        per_litre: 9,
                    },
                ]
            },
        ],
        comments:
            'For full protection on untreated wood, we recommend using 2 coats. The first coat soaks deeply into the wood and the second coat seals the wood at the surface for advanced protection. Further coats can be used to deepen the colour, or to refresh the coating after an extended period of time outdoors. To maintain the best protection we suggest recoating every 1-2 years. Coverage levels are to be used as a guide and may vary depending on the structure and the type of wood.',
    },
    {
        product: 'Shed and Fence Protector',
        handle: 'timbashield-shed-fence-protector',
        types: [
            {
                name: 'Shed and Fence',
                coverage: [
                    {
                        label: 'One Coat (Best Protection)',
                        per_litre: 6,
                    }
                ]
            },
            {
                name: 'Redecoration',
                coverage: [
                    {
                        label: 'One Coat',
                        per_litre: 6,
                    }
                ]
            },
        ],
        comments:
            'To maintain the best protection we suggest recoating every 1-2 years. Coverage levels are to be used as a guide and may vary depending on the structure and the type of wood',
    },
    {
        product: 'Garden Paints',
        handle: 'timbashield-garden-paint',
        types: [
            {
                name: 'Smooth Wood',
                coverage: [
                    {
                        label: 'One Coat (Standard Protection)',
                        per_litre: 7,
                    },
                    {
                        label: 'Two Coats (Best Protection)',
                        per_litre: 5,
                    },
                    {
                        label: 'Three Coats (Best Protection, Extra Coverage)',
                        per_litre: 3,
                    }
                ]
            },
            {
                name: 'Rough Wood',
                coverage: [
                    {
                        label: 'One Coat (Standard Protection)',
                        per_litre: 5,
                    },
                    {
                        label: 'Two Coats (Best Protection)',
                        per_litre: 3.5,
                    },
                    {
                        label: 'Three Coats (Best Protection, Extra Coverage)',
                        per_litre: 2,
                    }
                ]
            },
            {
                name: 'Redecoration',
                coverage: [
                    {
                        label: 'One Coat',
                        per_litre: 9,
                    }
                ]
            },
        ],
        comments:
            'For full protection on untreated wood, we recommend using 2 coats. On some darker surfaces an extra coat may be needed if a lighter colour is used to give full coverage. Coverage levels are to be used as a guide and may vary depending on the structure and type of wood.',
    },
]
